const DEFAULT_HIGHLIGHTS = [
  "Track referrals, approvals, and commission progress in one place",
  "Use the same premium Ceylon Web Mall branding across every auth screen",
  "Move from invitation to dashboard with a cleaner, warmer experience",
];

export default function AuthShell({
  portalLabel = "Referral Portal",
  badge = "Ceylon Web Mall",
  title,
  description,
  footer,
  children,
  highlights = DEFAULT_HIGHLIGHTS,
  heroTitle = "Grow with confident referrals and elegant account access.",
  heroDescription = "Bring users into a polished portal experience that feels connected to the wider Ceylon Web Mall brand from the very first screen.",
}) {
  return (
    <div className="relative overflow-hidden bg-[linear-gradient(180deg,#fffaf1_0%,#fff5e4_42%,#f5ead8_100%)] px-4 py-8 sm:px-6 lg:px-8 lg:py-10">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-[radial-gradient(circle_at_top,rgba(196,152,84,0.18),transparent_60%)]" />
      <div className="pointer-events-none absolute -left-16 top-24 h-52 w-52 rounded-full bg-[#ebcf9d]/30 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-10 h-64 w-64 rounded-full bg-[#c68a33]/15 blur-3xl" />

      <div className="relative mx-auto max-w-6xl">
        <div className="mb-5 flex items-center justify-between gap-4 text-sm text-[#7d6241]">
          <div className="inline-flex items-center rounded-full border border-[#ead7b0] bg-white/80 px-4 py-2 font-medium shadow-sm">
            {portalLabel}
          </div>
          <span className="hidden sm:block">
            Premium shopping, learning, and referral growth
          </span>
        </div>

        <div className="grid overflow-hidden rounded-[32px] border border-[#e7d1ad] bg-white/80 shadow-[0_32px_80px_-40px_rgba(89,51,18,0.45)] backdrop-blur xl:grid-cols-[1.05fr,0.95fr]">
          <div className="relative hidden min-h-full overflow-hidden xl:block">
            <img
              src="/img/hero-background.png"
              alt="Ceylon Web Mall showcase"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-[linear-gradient(160deg,rgba(18,46,72,0.9),rgba(69,39,15,0.76))]" />
            <div className="relative flex h-full flex-col justify-between p-10 text-white">
              <div>
                <div className="inline-flex items-center rounded-full border border-white/15 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.22em] text-[#f8dfac] backdrop-blur">
                  {badge}
                </div>
                <img
                  src="/user-portal-logo.png"
                  alt="Ceylon Web Mall"
                  className="mt-8 h-32 w-auto drop-shadow-[0_12px_24px_rgba(0,0,0,0.3)]"
                />
                <h2 className="mt-8 max-w-md text-4xl font-black leading-tight">
                  {heroTitle}
                </h2>
                <p className="mt-4 max-w-lg text-sm leading-7 text-white/80">
                  {heroDescription}
                </p>
              </div>

              <div className="space-y-3">
                {highlights.map((item) => (
                  <div
                    key={item}
                    className="rounded-2xl border border-white/12 bg-white/10 px-4 py-3 text-sm text-white/90 backdrop-blur"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="relative p-6 sm:p-8 lg:p-10 xl:p-12">
            <div className="mb-8 text-center xl:text-left">
              <img
                src="/user-portal-logo.png"
                alt="Ceylon Web Mall"
                className="mx-auto h-24 w-auto xl:hidden"
              />
              <div className="mt-5 inline-flex items-center rounded-full border border-[#ead7b0] bg-[#fff8ec] px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.22em] text-[#9b6b2f]">
                {badge}
              </div>
              <h1 className="mt-4 text-3xl font-black tracking-tight text-[#4e3520] sm:text-4xl">
                {title}
              </h1>
              <p className="mt-3 text-sm leading-7 text-[#7d6241] sm:text-base">
                {description}
              </p>
            </div>

            {children}

            {footer ? (
              <div className="mt-8 border-t border-[#f0dfc0] pt-6 text-center text-sm text-[#7d6241]">
                {footer}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
